module.exports = __webpack_public_path__ + "fonts/fa-solid-900.25d740d4.woff2";